<div class="content">
  <h2>{{ errorBarMessage }}</h2>
</div>
